import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle, CalendarCheck, Users, Megaphone, ChartLine } from "@phosphor-icons/react";
import api from "../lib/api";

const EMPTY = { nome: "", ristorante: "", email: "", telefono: "", messaggio: "" };

const inputCls = "w-full h-12 px-4 rounded-lg bg-zinc-900 border border-zinc-700 text-white text-sm placeholder-zinc-500 focus:outline-none focus:border-[#2ce0cb] transition-colors";

export default function RichiediInfo() {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/public/leads", form);
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invio non riuscito, riprova");
    } finally { setSending(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-white" data-testid="richiedi-info-page">
      <div className="max-w-5xl mx-auto px-5 py-10 sm:py-16">
        <img src="/vetrina/logo-dishenda.png" alt="Dishenda" className="h-12" data-testid="richiedi-logo" />

        <div className="grid lg:grid-cols-2 gap-10 mt-10 items-start">
          <div>
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-tight">
              Il gestionale che fa tornare i tuoi clienti
            </h1>
            <p className="mt-4 text-zinc-400 text-base sm:text-lg leading-relaxed">
              Prenotazioni, sala, CRM, coupon, gift card, sondaggi e marketing automatico.
              Tutto in un'unica app pensata per i ristoranti.
            </p>
            <div className="mt-8 space-y-3">
              {[
                [CalendarCheck, "Prenotazioni e panoramica sale in tempo reale"],
                [Users, "CRM clienti con tag e segmenti intelligenti"],
                [Megaphone, "Campagne email e WhatsApp con statistiche reali"],
                [ChartLine, "Fidelity, coupon e sondaggi automatici post-visita"],
              ].map(([Icon, txt]) => (
                <div key={txt} className="flex items-center gap-3 text-sm text-zinc-300">
                  <div className="w-9 h-9 rounded-lg bg-[#2ce0cb]/10 border border-[#2ce0cb]/30 flex items-center justify-center shrink-0">
                    <Icon size={18} weight="bold" className="text-[#2ce0cb]" />
                  </div>
                  {txt}
                </div>
              ))}
            </div>
            <p className="mt-8 text-xs text-zinc-500">Prova gratuita di 14 giorni · Nessuna carta richiesta · Attivazione in 5 minuti</p>
          </div>

          <div className="bg-zinc-900/60 border border-zinc-800 rounded-2xl p-6 sm:p-8">
            {done ? (
              <div className="text-center py-10" data-testid="lead-success">
                <CheckCircle size={56} weight="fill" className="text-emerald-400 mx-auto" />
                <h2 className="font-display text-2xl font-bold mt-4">Richiesta inviata!</h2>
                <p className="text-zinc-400 text-sm mt-2">Ti ricontattiamo entro 24 ore lavorative con info e prezzi.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-3" data-testid="lead-form">
                <h2 className="font-display text-xl font-bold mb-1">Richiedi info e prezzi</h2>
                <p className="text-xs text-zinc-500 mb-3">Compila il form: ti ricontattiamo noi.</p>
                <input required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  placeholder="Il tuo nome e cognome *" className={inputCls} data-testid="lead-nome" />
                <input value={form.ristorante} onChange={(e) => setForm({ ...form, ristorante: e.target.value })}
                  placeholder="Nome del ristorante" className={inputCls} data-testid="lead-ristorante" />
                <div className="grid sm:grid-cols-2 gap-3">
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="Email *" className={inputCls} data-testid="lead-email" />
                  <input value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })}
                    placeholder="Telefono" className={inputCls} data-testid="lead-telefono" />
                </div>
                <textarea value={form.messaggio} onChange={(e) => setForm({ ...form, messaggio: e.target.value })}
                  placeholder="Messaggio (facoltativo)" rows={3}
                  className={`${inputCls} h-auto py-3 resize-none`} data-testid="lead-messaggio" />
                <button disabled={sending} data-testid="lead-submit"
                  className="w-full h-12 rounded-lg bg-[#2ce0cb] text-zinc-950 font-bold text-sm hover:bg-[#6ef0e0] active:scale-[0.98] transition disabled:opacity-50">
                  {sending ? "Invio in corso..." : "Richiedi informazioni"}
                </button>
                <p className="text-[10px] text-zinc-600 text-center">Inviando accetti di essere ricontattato da Dishenda. Nessuno spam, promesso.</p>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
